import React from "react";
import ProductCard from "../../../../../Reusable/Product Card/ProductCard";

// -----------------------------importing Data-----------------
import { NaranKaghanHotelsData } from "./Naran Kaghan Hotels Mapping Data";

// -------------------mapping() function------------------------

function NaranKaghanHotelsProductCard() {
  return (
    <>
      {NaranKaghanHotelsData.map((product) => {
        return (
          <ProductCard
            key={product.id}
            img={product.img}
            date={product.date}
            month={product.month}
            price={product.price}
            detail={product.detail}
            path={product.path}
          />
        );
      })}
    </>
  );
}

export default NaranKaghanHotelsProductCard;
